import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ThemeProvider } from '@/components/theme-provider'
import { ModeToggle } from '@/components/mode-toggle'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { saveTokenFromHash } from '@/lib/sso'
import { useAuthStore } from '@/stores/authStore'
import { Spinner } from '@/components/kristoff/spinner'

export default function SSOCallbackPage() {
  const { t } = useTranslation('common')
  const [isProcessing, setIsProcessing] = useState(true)
  const [error, setError] = useState('')
  const { isAuthenticated } = useAuthStore()

  useEffect(() => {
    const processCallback = () => {
      console.log('=== SSO Callback Page 开始处理 ===')
      console.log('当前URL:', window.location.href)
      console.log('URL hash:', window.location.hash)
      console.log('URL search:', window.location.search)
      console.log('完整URL信息:', {
        href: window.location.href,
        origin: window.location.origin,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash
      })
      
      try {
        // 尝试从hash中提取token
        console.log('开始尝试从hash中提取token...')
        const success = saveTokenFromHash()
        console.log('saveTokenFromHash 返回结果:', success)
        
        if (success) {
          console.log('✅ 成功提取token，准备重定向到仪表盘')
          
          // 立即初始化用户信息（包括username）
          const { initializeFromSSO } = useAuthStore.getState()
          initializeFromSSO()
          console.log('✅ 用户信息初始化完成')
          
          // 成功提取token，重定向到仪表盘
          setTimeout(() => {
            console.log('执行重定向到 /zh/dashboard')
            window.location.href = '/zh/dashboard'
          }, 1000)
        } else {
          console.log('❌ 未找到有效的认证令牌')
          setError('未找到有效的认证令牌')
          setIsProcessing(false)
        }
      } catch (err) {
        console.error('❌ 处理认证回调时发生错误:', err)
        setError('处理认证回调时发生错误')
        setIsProcessing(false)
      }
    }

    processCallback()
  }, [])

  // 如果已认证，直接重定向
  if (isAuthenticated) {
    return <Navigate to="/zh/dashboard" replace />
  }

  return (
    <ThemeProvider
      defaultTheme="system"
      storageKey="theme"
    >
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="absolute top-4 right-4 flex items-center space-x-2">
          <ModeToggle />
          <LanguageSwitcher />
        </div>
        
        <div className="w-full max-w-md space-y-8 mt-40">
          <div className="text-center">
            <h1 className="text-3xl font-bold tracking-tight">正在处理登录...</h1>
            <p className="text-muted-foreground mt-2">
              {isProcessing ? '请稍候，正在验证您的身份' : '登录处理完成'}
            </p>
          </div>

          <div className="text-center">
            {isProcessing ? (
              <div className="space-y-4">
                <Spinner size="lg" className="mx-auto" />
                <p className="text-sm text-muted-foreground">正在验证身份信息...</p>
              </div>
            ) : error ? (
              <div className="space-y-4">
                <div className="text-destructive">
                  <p className="font-medium">登录失败</p>
                  <p className="text-sm mt-1">{error}</p>
                </div>
                <button
                  onClick={() => window.location.href = '/'}
                  className="text-primary hover:underline text-sm"
                >
                  返回首页
                </button>
              </div>
            ) : (
              <div className="space-y-4">
                <div className="text-green-600">
                  <p className="font-medium">登录成功</p>
                  <p className="text-sm mt-1">正在跳转到仪表盘...</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  )
}
